import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { FilterForm } from 'src/app/interfaces/groups-filters/groups-filters.interface';
import { GroupMemberInterface } from 'src/app/interfaces/groups/group.interface';
import { FilterService } from 'src/app/services/marketing-campaigns/marketing-campaigns-group/marketing-campaign-groups-ids-form';

@Component({
  selector: 'app-filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.scss']
})
export class FilterFormComponent {
  @Input() filters!: FormArray<FormGroup<FilterForm>>;
  @Input() groupInterface!: GroupMemberInterface;
  @Output() addFilter = new EventEmitter<void>();
  @Output() removeFilter = new EventEmitter<number>();
  @Output() filtersChanged = new EventEmitter<void>();

  constructor(private filterService: FilterService) {}

  onAddFilter(): void {
    this.addFilter.emit();
  }

  onRemoveFilter(index: number): void {
    this.removeFilter.emit(index);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
